// extracted by mini-css-extract-plugin
module.exports = {"label":"Label_label__3Gqg6","leftText":"Label_leftText__iJNxw","rightText":"Label_rightText__3YOK0"};